// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0b88bce6","239":"a395fe69","453":"96791bff","455":"3a2aed61"}[chunkId] + ".chunk.js";
};